export default __webpack_public_path__ + "media/2ca9ce5b34acfc9862bc9718b8803954126d920074e69564dd2085102feb71c5.svg";